import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { IProcessedProfile } from '@/components/profileDetail';
import {
  DownloadPopup,
  isDownloadableUrl,
  LeavingPopup,
  sendMarketoForm,
} from '@/pages/profile';
import { PopupTypes } from '@/pages/profile/downloadGate/popupTypes';
import { withGlobalScroll } from '@/shared/withGlobalScroll';
import { useStores } from '@/stores';

interface DownloadGateProps {
  profile: IProcessedProfile;
  downloadUrl: string;
  onClose: () => void;
}

type PopupType =
  | PopupTypes.LoginOption
  | PopupTypes.Download
  | PopupTypes.Leaving
  | null;

const DownloadGatePure: FC<DownloadGateProps> = ({
  profile,
  downloadUrl,
  onClose,
}) => {
  const [popupType, setPopupType] = useState<PopupType>(null);
  const { userStore } = useStores();

  const showGetAppPopup = () => {
    const type = isDownloadableUrl(downloadUrl)
      ? PopupTypes.Download
      : PopupTypes.Leaving;
    setPopupType(type);
  };

  const handleAfterSignIn = () => {
    showGetAppPopup();
    sendMarketoForm(profile._id, profile.appName);
  };

  useEffect(() => {
    if (userStore.isLoggedIn) {
      handleAfterSignIn();
    } else {
      showGetAppPopup();
    }
  }, []);

  return (
    <>
      {popupType === PopupTypes.Download && (
        <DownloadPopup
          profile={profile}
          downloadUrl={downloadUrl}
          onClose={onClose}
        />
      )}
      {popupType === PopupTypes.Leaving && (
        <LeavingPopup leavingUrl={downloadUrl} onClose={onClose} />
      )}
    </>
  );
};

export const DownloadGate = withGlobalScroll(observer(DownloadGatePure));
